// extracted by mini-css-extract-plugin
export default {"arrow":"VhFUm","circleChevron":"DNbg0","chevron":"YS56L","isArrowWhite":"AAV3W","right":"ozKdJ"};